import { render, staticRenderFns } from "./EditBranches.vue?vue&type=template&id=30a151b1&"
import script from "./EditBranches.vue?vue&type=script&lang=js&"
export * from "./EditBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports